import React from 'react'

import './buttonBase.scss'
import PropTypes from 'prop-types'

/** button base used for any clickable element which doesnt look like a button  */
const ButtonBase = ({ children, className, ...rest }) => {
  return <button className={`Suc-button-base ${className}`} type={'button'} {...rest}>{children}</button>
}

ButtonBase.propTypes = {
  /** custom classname */
  className: PropTypes.string
}

ButtonBase.defaultProps = {
  className: ''
}

export default ButtonBase
